module.exports = __webpack_public_path__ + "assets/6a260aca9120ed2d2579077087785bc0.jpg";